import React from "react";

import { joinClassNames } from "@/utils/classNames";

import {
  StyledSection,
  StyledSectionContentContainer,
  StyledSectionHeading,
} from "../PaypipeIdPage.styles";
import SectionTitle from "./SectionTitle";

const Section: React.FC<{
  title: React.ReactNode;
  icon: string;
  heading?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}> = ({ title, icon, heading, children, className }) => {
  return (
    <StyledSection className={joinClassNames(className, "section")}>
      <SectionTitle title={title} icon={icon} className="section__title" />
      <StyledSectionHeading size="lg" className="mt-5 section__heading">
        {heading}
      </StyledSectionHeading>
      <StyledSectionContentContainer>{children}</StyledSectionContentContainer>
    </StyledSection>
  );
};

export default Section;
